import { useQuery } from '@tanstack/react-query';
import { useApiAppLegacy } from '@/shared/api';
import { plantsWithDevicesQueryOptions } from './plants.query-options';

/**
 * 발전소+설비 목록 query — 알림 필터 select 용. v3 (`useApiAppLegacy`). mock/real 은 `USE_MOCK`.
 * 필터 `Sheet` 가 열릴 때만 필요하면 호출처에서 `enabled` 로 게이트할 수 있다(현재는 항상).
 */
export function usePlantsWithDevicesQuery() {
  const api = useApiAppLegacy();
  return useQuery(plantsWithDevicesQueryOptions(api));
}
